import Head from 'next/head';
import type { ShareMetaTagType } from '../lambdas/utils/html';

export const ShareMetaTags = ({
  shareMetadata,
}: {
  shareMetadata?: ShareMetaTagType[];
}) => {
  if (!shareMetadata?.length) {
    return null;
  }

  return (
    <Head>
      {shareMetadata.map(({ property, content }) => (
        <meta key={property} property={property} content={content} />
      ))}
    </Head>
  );
};
